<!-- Modal Dialog -->
<div class="modal fade"
     [class.show]="isOpen()"
     [style.display]="isOpen() ? 'block' : 'none'"
     tabindex="-1"
     role="dialog"
     [attr.aria-modal]="isOpen() ? 'true' : null"
     (click)="onBackdropClick($event)">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="modal-header">
          <h5 class="modal-title">
            <i class="bi bi-person-plus-fill text-primary me-2"></i>
            Quick Add Customer
          </h5>
          <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
        </div>

        <div class="modal-body">
          <!-- API Error -->
          @if (apiError()) {
            <div class="alert alert-danger alert-dismissible fade show py-2" role="alert">
              <i class="bi bi-exclamation-circle me-1"></i>{{ apiError() }}
              <button type="button" class="btn-close py-2" aria-label="Close" (click)="apiError.set(null)"></button>
            </div>
          }

          <div class="row g-3">
            <div class="col-12">
              <label class="form-label">Customer Name <span class="text-danger">*</span></label>
              <input type="text" class="form-control" formControlName="name"
                     placeholder="e.g., Smith Farms"
                     [class.is-invalid]="isFieldInvalid('name')">
              <div class="invalid-feedback">Please enter a customer name (at least 2 characters)</div>
            </div>

            <div class="col-md-6">
              <label class="form-label d-flex align-items-center gap-2">
                Phone
                <span class="badge bg-secondary-subtle text-secondary">Optional</span>
              </label>
              <input type="tel" class="form-control" formControlName="phone"
                     mask="(000) 000-0000"
                     [validation]="false"
                     placeholder="(555) 123-4567">
            </div>

            <div class="col-md-6">
              <label class="form-label d-flex align-items-center gap-2">
                Email
                <span class="badge bg-secondary-subtle text-secondary">Optional</span>
              </label>
              <input type="email" class="form-control" formControlName="email"
                     placeholder="customer@example.com"
                     [class.is-invalid]="isFieldInvalid('email')">
              <div class="invalid-feedback">Please enter a valid email address</div>
            </div>
          </div>

          <div class="form-text mt-3">
            <i class="bi bi-info-circle me-1"></i>
            You can add address and other details later from the Customers page.
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" (click)="close()">
            Cancel
          </button>
          <button type="submit" class="btn btn-primary" [disabled]="isSaving()">
            <ng-container *ngIf="!isSaving()">
              <i class="bi bi-plus-lg me-1"></i>Add Customer
            </ng-container>
            <ng-container *ngIf="isSaving()">
              <span class="spinner-border spinner-border-sm me-1" role="status"></span>
              Adding...
            </ng-container>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Modal Backdrop Overlay -->
<div
  class="modal-backdrop fade"
  [class.show]="isOpen()"
  *ngIf="isOpen()"
></div>
